<template>
  <v-card min-width="250">
    <v-toolbar dark flat color="primary">
      <v-toolbar-title> Account Login </v-toolbar-title>
    </v-toolbar>
    <v-card-text style="padding: 20px 50px 20px 50px">
      <v-alert type="error" v-model="alert" dense dismissible>{{
        errorMessage
      }}</v-alert>
      <v-form ref="form" v-model="valid" @submit.prevent="login">
        <v-row>
          <v-col class="py-0" cols="12" sm="6">
            <v-text-field
              label="Email"
              outlined
              dense
              v-model.trim="email"
              type="text"
              :rules="[rules.email, rules.required]"
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="6">
            <v-text-field
              label="Password"
              id="password"
              name="password"
              outlined
              dense
              v-model.trim="password"
              :type="showPassword ? 'text' : 'password'"
              :rules="[rules.required]"
            >
              <template v-slot:append>
                <v-checkbox
                  class="pa-0 ma-0"
                  v-model="showPassword"
                  style="width: 25px; height: 25px !important"
                  on-icon="mdi-eye"
                  off-icon="mdi-eye-off"
                ></v-checkbox>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer />
          <v-btn
            class="primary px-5 body-2 text-capitalize font-weight-medium mx-3"
            dark
            :loading="loading"
            type="submit"
            @click="loading = true"
            elevation="0"
            >Login</v-btn
          >
        </v-row>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <a
        :href="'password-reset'"
        class="body-2 font-weight-medium text--disabled"
        style="position: absolute; bottom: 10px; left: 10px"
        >Forgot password?</a
      >
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-center ma-4">
          <span class="font-weight-medium body-1 text--secondary"
            >Don't have an account?
            <a @click="$router.push('signup')">Signup</a></span
          >
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import router from '@/router'
const firebase = require('../firebaseConfig')
export default {
  name: 'LoginForm',
  data: () => ({
    email: null,
    password: null,
    showPassword: false,
    valid: false,
    errorMessage: '',
    alert: false,
    loading: false,
    rules: {
      required: (value) => !!value || 'Required.',
      email: (value) => {
        const pattern =
          /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g
        return pattern.test(value) || 'Must be a valid email'
      },
    },
  }),
  methods: {
    login() {
      this.validate()
      if (this.valid) {
        firebase.auth
          .signInWithEmailAndPassword(this.email, this.password)
          .then((user) => {
            this.$store.commit('SET_CURRENT_USER', user.user)
            this.$store.commit('SET_AUTHENTICATED', true)
            this.$store.dispatch('fetchUserProfile')
            router.push('dashboard')
          })
          .catch((err) => {
            this.errorMessage = err.message
            this.alert = true
            this.loading = false
          })
      }
    },
    validate() {
      this.$refs.form.validate()
    },
  },
}
</script>
